import { elementReady } from 'theme-utilities';
import initFormObserver from './modules/init';

elementReady('.mcfly-form').then((form) => {
	if (form instanceof NodeList) {
		form.forEach((f) => {
			initFormObserver(f);
		});
	} else {
		initFormObserver(form);
	}
});
